
import { Component, Prop, Vue } from 'vue-property-decorator';
import HrmDataTable from '@/components/common/hrm-data-table/HrmDataTable.vue';
import { Getter } from '@/decorators';
import { HRMUserEngagementTimeSheetDTO, UserDTO } from '@/models';

@Component({
  components: {
    HrmDataTable
  }
})
export default class HrmTimeSheetSummary extends Vue {
  @Prop() hrmTimeSheets!: HRMUserEngagementTimeSheetDTO[];

  @Getter('app/currentUser') user: UserDTO;
}
